<template>
  <div class="Create alignment">
    <v-container>
      <v-row dense>
        <v-col>
          {{ title }}
        </v-col>
      </v-row>
      <v-row dense>
        <v-col>
          <v-btn class="styleButtonTop border" @click="back()">
            <v-icon left>fas fa-check-circle</v-icon>
            {{ $t("SearchMenu.Button.Back") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { Trans } from "@/plugins/Translation";
import router from "@/router/index.js";

export default {
  data() {
    return {
      title: Trans.i18n.t("Completed.Title"),
    };
  },

  created() {
    // console.log("Completed", this.$store.getters.GET_requestAdded);
    if (this.$store.getters.GET_requestAdded) {
      this.title = Trans.i18n.t("Completed.TitleAdded");
    }
  },
  methods: {
    back() {
      router.push({ name: "home" });
    },
  },
};
</script>